module.exports = __webpack_public_path__ + "img/bg_complete_static.948ef768.png";